export default {"src":"/_next/static/media/ico_heart.f86d7c8c.svg","height":24,"width":25};